import Tooltip from "@mui/material/Tooltip";
import React, {useMemo} from "react";

import {formatFromNow, formatFullDate} from "../../utils/time";

interface MomentWithTooltipProps {
    date: string | number | Date;
    tooltipPlacement?: "top" | "bottom" | "left" | "right";
    className?: string;
    /** Renders the tooltip title from the formatted full date. */
    customTooltipRenderer?: (formattedDate: string) => NonNullable<React.ReactNode>;
}

/**
 * Lightweight mirror of the main app's MomentWithTooltip: relative "from now"
 * text (moment.js thresholds) with a full-date tooltip.
 */
export const MomentWithTooltip: React.FC<MomentWithTooltipProps> = React.memo(function MomentWithTooltip({
    date,
    tooltipPlacement = "bottom",
    className,
    customTooltipRenderer,
}) {
    const tooltipTitle = useMemo(() => {
        const formattedDate = formatFullDate(date);
        return customTooltipRenderer ? customTooltipRenderer(formattedDate) : formattedDate;
    }, [date, customTooltipRenderer]);

    return (
        <Tooltip title={tooltipTitle} placement={tooltipPlacement}>
            <span className={className}>{formatFromNow(date)}</span>
        </Tooltip>
    );
});

export default MomentWithTooltip;
